import AddCompany from "../../Components/Modals/AddCompany";
import Table from "../../Components/Table";
import { deleteCompanyId, getCompanies } from "../../Services/MasterService";

const Company = () => {
    const columns = [
        {
            label: "Name",
            value: "name"
        },
        {
            label: "Alias",
            value: "alias"
        },
        {
            label: "Address",
            value: "address"
        },
        {
            label: "Domain",
            value: "domain"
        },
        {
            label: "Logo",
            value: "logo",
            renderValue: (value) => {
                return (
                    <img width={70} src={value} alt="..." class="img-thumbnail" />
                )
            }
        },
        {
            label: "Disabled",
            value: "is_disabled",
            renderValue: (value) => {
                return (
                    Boolean(value) ? "Yes" : "No"
                )
            }
        },
        {
            label: "Status",
            value: "status_name",
        }
    ];

    const renderAddModal = (openAddModal, setOpenAddModal) => {
        return (
            <AddCompany data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
        )
    };

    return (
        <Table
            api={getCompanies}
            columns={columns}
            title={"Companies Master"}
            addModal={renderAddModal}
            showAddButton={true}
            showExportButton={true}
            deleteApi={deleteCompanyId}
        />
    );
}

export default Company;